var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.number==2)?_vm._t("intro"):_vm._e(),_c('p',{class:_vm.className,style:({textAlign: 'center', color: _vm.color, fontSize: _vm.countSize, fontWeight: _vm.countWeight})},[_c('span',{attrs:{"id":_vm.idName}},[_vm._v(_vm._s(_vm.startVal))]),_c('span',[_vm._v(_vm._s(_vm.unit))])]),(_vm.number!=2)?_vm._t("intro"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }